module.exports = __webpack_public_path__ + "static/media/completed trip.efec7b57.svg";